import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EUserType } from "../../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/dependencies/getIsBeelineError/api/constants";
import { getUserType } from "../../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput/utils";
import { kopeikiToRubles } from "../../../../components/PaymentContainer/components/PaymentSelection/components/PaymentDetailsSection/InputSection/components/SumInput/utils";
import { EStatus } from "../../../../../constants";
import { getWindow } from "../../../../../utils/window";
import { getSmsCode, processSmsStatus } from "../../logic/utils";
import { getCommonParamsFromState } from "../../utils";
import { getIsSmsStatusReceived } from "../utils";
import { sendCardPayment } from "./api";
import { redirectToPayment } from "./api/index.legacy";
export var getSendCardPayment = function getSendCardPayment(_ref) {
  var getUserAccountInfo = _ref.getUserAccountInfo,
    getContent = _ref.getContent,
    isSmsResend = _ref.isSmsResend,
    login = _ref.login;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var _getWindow$paymentTog, _getWindow;
      var state, _getUserAccountInfo, accountNumber, _getCommonParamsFromS, from, isAuthenticated, sum, to, bindingId, type, _getContent, paymentRBS, loginUrl, _ref3, isRbsEnabled, PAYMENT_RBS, orderDate, status, isSmsStatusReceived;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            _getUserAccountInfo = getUserAccountInfo(), accountNumber = _getUserAccountInfo.accountNumber;
            _getCommonParamsFromS = getCommonParamsFromState(state, accountNumber !== null && accountNumber !== void 0 ? accountNumber : state.phoneInput.value, !!accountNumber), from = _getCommonParamsFromS.from, isAuthenticated = _getCommonParamsFromS.isAuthenticated, sum = _getCommonParamsFromS.sum, to = _getCommonParamsFromS.to, bindingId = _getCommonParamsFromS.bindingId;
            type = to ? getUserType(to) : EUserType.Mobile;
            _getContent = getContent(), paymentRBS = _getContent.paymentRBS, loginUrl = _getContent.loginUrl;
            _ref3 = (_getWindow$paymentTog = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.paymentToggles) !== null && _getWindow$paymentTog !== void 0 ? _getWindow$paymentTog : {}, isRbsEnabled = _ref3.isRbsEnabled;
            PAYMENT_RBS = isRbsEnabled !== null && isRbsEnabled !== void 0 ? isRbsEnabled : paymentRBS;
            if (isAuthenticated) {
              _context.next = 11;
              break;
            }
            _context.next = 10;
            return login();
          case 10:
            return _context.abrupt("return", EStatus.Processing);
          case 11:
            if (PAYMENT_RBS) {
              _context.next = 15;
              break;
            }
            _context.next = 14;
            return redirectToPayment({
              ctn: from,
              isAuth: isAuthenticated,
              sum: kopeikiToRubles(sum),
              type: type === EUserType.Mobile ? 'mobile' : 'internet'
            });
          case 14:
            return _context.abrupt("return", EStatus.Processing);
          case 15:
            orderDate = new Date().toISOString();
            _context.next = 18;
            return sendCardPayment({
              loginData: {
                isAuthenticated: isAuthenticated,
                loginUrl: loginUrl
              },
              orderData: {
                ctn: from,
                orderDate: orderDate,
                payeePhone: to,
                sum: sum
              },
              bindingId: bindingId,
              smsCode: getSmsCode(getState(), !!isSmsResend)
            });
          case 18:
            status = _context.sent;
            isSmsStatusReceived = status && getIsSmsStatusReceived(status);
            if (!isSmsStatusReceived) {
              _context.next = 23;
              break;
            }
            processSmsStatus(setState, status !== null && status !== void 0 ? status : undefined);
            return _context.abrupt("return", undefined);
          case 23:
            return _context.abrupt("return", status !== null && status !== void 0 ? status : undefined);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};